module.exports = __webpack_public_path__ + "img/card2Img.7fac6129.png";